import { createI18n } from 'vue-i18n';
import translations from './i18n/vue-i18n-locales';

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'da',
    fallbackLocale: 'en',
    messages: translations,
});

export const setLocale = (locale) => {
    if (translations[locale]) {
        i18n.global.locale.value = locale;
    } else {
        console.error(`Locale ${locale} not found.`);
    }
};

export default i18n;